import React, { Component } from 'react';
import Socialicons from '../All/Socialicons';
import EmailSignup from '../All/EmailSignup';

class Team extends Component {
    render() {
      return (
          <div id="contact">
            <h1>Contact</h1>
              <div className="two-columns">
                <div className="one">
                  <div className="address">
                    <div className="extended-line"><div className="line"></div><p>718–418–9000</p></div>
                    <div className="extended-line"><div className="line"></div><p>200 Morgan Ave</p></div>
                    <p>Studio#3, Brooklyn</p>
                    <p>New York, 11237</p>
                  </div>
                </div>
                <div className="two">
                  <a href="mailto:info@anywaysnyc.com">info@anywaysnyc.com</a>
                </div>
              </div>
              <div className="signup">
                <EmailSignup includeName={false} />
              </div>
              <Socialicons email={true} />
          </div>
      );
    }
}

export default Team;


// WEBPACK FOOTER //
// ./src/components/Info/Contact.js